import { zodResolver } from '@hookform/resolvers/zod'
import {
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Dialog,
  DialogContent,
} from '@mui/material'
import dayjs from 'dayjs'
import { useCallback, useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { MdClose } from 'react-icons/md'
import InputMask from 'react-input-mask'
import { z } from 'zod'
import { AgendaContext } from '../../'
import { GlobalContext } from '../../../../../App'
import { metodoPrograma } from '../../../../../components/api'
import Table from '../../../../../components/Table/Table'
import { Label } from '../../../../../components/ui/label'
import { DadosCadastrais } from '../../../atendimentoMedico/components/DadosCadastrais'
import { Actions } from './../create-schedule/components/actions'
import { TextStatics } from '../TextStatics'
import { PacienteInput } from './components/paciente-input'
import { NumericFormat } from 'react-number-format'
import AutoComplete from '../../../../../components/AutoComplete/AutoComplete'

const createAgendamento = z.object({
  nmMedico: z.string(),
  idAgendamento: z.number().nullable(),
  idLocalAtendimento: z.number(),
  idAgenda: z.number(),
  cdCpf: z.string(),
  dsAgendamento: z.string(),
  dtInicio: z.string(),
  dtFim: z.string(),
  idTipoAgendamento: z
    .number()
    .nullable()
    .refine((value) => value !== null, {
      message: 'Tipo de agendamento é obrigatório',
    }),
  dsEmail: z.string().optional(),
  nrTelefone: z.string().optional(),
  tpEstado: z.string(),
  idPaciente: z.number().nullable(),
  idConvenio: z.number().nullable().optional(),
  dsObservacao: z.string(),
  dtExclusao: z.string().nullable(),
})

const initialValues = (
  agendamentoSelecionado,
  medico,
  agenda,
  localAtendimento,
) => ({
  nmMedico: medico?.nmMedico,
  idAgendamento: agendamentoSelecionado.data?.[0] || null,
  idLocalAtendimento: localAtendimento[0],
  idAgenda: agenda[0],
  cdCpf: agendamentoSelecionado.data?.[7]?.cdCpf || '',
  dsAgendamento: agendamentoSelecionado.data?.[3] || '',
  dtInicio: agendamentoSelecionado.start
    ? dayjs(agendamentoSelecionado.start).format('YYYY-MM-DD HH:mm')
    : '',
  dtFim: agendamentoSelecionado.end
    ? dayjs(agendamentoSelecionado.end).format('YYYY-MM-DD HH:mm')
    : '',
  idTipoAgendamento: agendamentoSelecionado.data?.[4]?.idTipoAgendamento
    ? agendamentoSelecionado.data?.[4]?.idTipoAgendamento
    : null,
  tpEstado: agendamentoSelecionado.data?.[5]?.tpEstado || '1',
  idPaciente: agendamentoSelecionado.data?.[7]?.idPaciente || null,
  idConvenio: agendamentoSelecionado.data?.[6]?.idConvenio
    ? agendamentoSelecionado.data?.[6]?.idConvenio
    : null,
  dsObservacao: agendamentoSelecionado.data?.[9] || '',
  dtExclusao: agendamentoSelecionado.data?.[8] || null,
  dsEmail: agendamentoSelecionado.data?.[15] || '',
  nrTelefone: agendamentoSelecionado.data?.[14] || '',
  vlConsulta: agendamentoSelecionado.data?.[12] || 0,
  acAtendimento: agendamentoSelecionado.data?.[16] || [],
  idAtendimento: agendamentoSelecionado.data?.[16]?.[0]?.[0] || null,
})

export const ScheduleEditor = ({ listaAgendamentos }) => {
  const { agendamentoSelecionado, medico, dispatch } = useContext(AgendaContext)
  const { agenda, localAtendimento } = useContext(GlobalContext)

  const [tiposAgendamento, setTiposAgendamento] = useState([])
  const [servicos, setServicos] = useState([])
  const [isModalOpen, setModalOpen] = useState(false)
  const [isRegisterModalOpen, setIsRegisterModal] = useState(false)

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues(
      agendamentoSelecionado,
      medico,
      agenda,
      localAtendimento,
    ),
    resolver: zodResolver(createAgendamento),
  })
  const getLists = useCallback(() => {
    metodoPrograma('listaTipoAgendamento', {
      idLocalAtendimento: localAtendimento[0],
    }).then((res) => {
      if (res.status) {
        setTiposAgendamento(res.lista)
      }
    })
  }, [localAtendimento])

  const salvar = async (values) => {
    if (!values.idPaciente) {
      setModalOpen(true)
    } else {
      proceedWithAppointmentConfirmation(values)
    }
  }

  const proceedWithAppointmentConfirmation = async (values) => {
    const obj = {
      ...values,
      idTipoAgendamento: values.idTipoAgendamento
        ? parseInt(values.idTipoAgendamento)
        : null,
      idConvenio: values.idConvenio ? parseInt(values.idConvenio) : null,
      idServico: values.idServico ? parseInt(values.idServico) : null,
      vlConsulta: watch('vlConsulta'),
      dtInicio: values.dtInicio
        ? dayjs(values.dtInicio).format('YYYY-MM-DD HH:mm')
        : undefined,
      dtFim: values.dtFim
        ? dayjs(values.dtFim).format('YYYY-MM-DD HH:mm')
        : undefined,
      nrTelefone: values.nrTelefone ? values.nrTelefone.replace(/\D/g, '') : '',
      cdCpf: values?.cdCpf ? values.cdCpf.replace(/[\s.-]/g, '') : undefined,
      idAtendimento: watch('idAtendimento'),
    }
    metodoPrograma('salva', obj).then((res) => {
      if (res.status) {
        listaAgendamentos()
        fecharModal()
      }
    })
  }

  const fecharModal = () => {
    listaAgendamentos()
    dispatch({
      field: 'agendamentoSelecionado',
      value: { data: null, modal: false },
    })
  }

  useEffect(() => {
    if (!watch('idTipoAgendamento')) return
    metodoPrograma('getServicoDoTipoDeAgendamento', {
      idTipoAgendamento: watch('idTipoAgendamento'),
    }).then((res) => {
      if (res.status) {
        setServicos(res.lista)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch('idTipoAgendamento')])

  useEffect(() => {
    getLists()
  }, [getLists])

  const disabledOpcoes = watch('tpEstado') === '1' || watch('tpEstado') === '6'

  const disabledSalvar = watch('tpEstado') !== '1'

  const disabledExcluir = watch('tpEstado') !== '1'

  const disabledFinalizar =
    watch('tpEstado') !== undefined && watch('tpEstado') !== '5'

  const alteraHorario = (campo, horario) => {
    const dataHoraAtual = watch(campo)

    if (!dataHoraAtual || !horario) return

    const [hora, minuto] = horario.split(':').map(Number)
    const novaDataHora = dayjs(dataHoraAtual)
      .hour(hora)
      .minute(minuto)
      .second(0)

    setValue(campo, novaDataHora.format('YYYY-MM-DD HH:mm'), {
      shouldDirty: true,
      shouldValidate: true,
    })
  }

  return (
    <Dialog
      open={agendamentoSelecionado.modal}
      onClose={fecharModal}
      maxWidth="md"
      fullWidth
    >
      <DialogContent>
        <div className="overflow-x-hidden p-4">
          {isModalOpen ? (
            isRegisterModalOpen ? (
              <DadosCadastrais
                pacienteSelecionado={{
                  nmPaciente: watch('dsAgendamento'),
                  cdCpf: watch('cdCpf'),
                }}
                onCancel={() => setIsRegisterModal(false)}
                onConfirm={(idPaciente) => {
                  setIsRegisterModal(false)
                  proceedWithAppointmentConfirmation({
                    ...watch(),
                    idPaciente,
                  })
                }}
              />
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <h1>Paciente não esta cadastrado no sistema</h1>
                  <h4>Deseja cadastrar como um novo paciente?</h4>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Button
                    variant="contained"
                    onClick={() => {
                      setModalOpen(false)
                      proceedWithAppointmentConfirmation(watch())
                    }}
                  >
                    Concluir sem cadastrar
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setIsRegisterModal(true)}
                  >
                    Cadastrar
                  </Button>
                </Grid>
              </Grid>
            )
          ) : (
            <form onSubmit={handleSubmit(salvar)} style={{ padding: '1rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} className="flex justify-between">
                  <TextStatics
                    tpEstado={agendamentoSelecionado.data?.[5]?.tpEstado}
                  />
                  <IconButton
                    title="Fechar modal"
                    onClick={() => fecharModal()}
                  >
                    <MdClose />
                  </IconButton>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Controller
                    name="dtInicio"
                    control={control}
                    render={({ field: { value, onBlur, ref } }) => (
                      <TextField
                        fullWidth
                        inputRef={ref}
                        label="Hora Início"
                        type="time"
                        value={value ? dayjs(value).format('HH:mm') : ''}
                        onChange={(e) =>
                          alteraHorario('dtInicio', e.target.value)
                        }
                        onBlur={onBlur}
                        variant="outlined"
                        margin="dense"
                        size="small"
                        disabled={
                          watch('tpEstado') !== undefined &&
                          (watch('tpEstado') === '5' ||
                            watch('tpEstado') === '6')
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controller
                    name="dtFim"
                    control={control}
                    render={({ field: { value, onBlur, ref } }) => (
                      <TextField
                        fullWidth
                        inputRef={ref}
                        label="Hora Fim"
                        type="time"
                        value={value ? dayjs(value).format('HH:mm') : ''}
                        onChange={(e) => alteraHorario('dtFim', e.target.value)}
                        onBlur={onBlur}
                        variant="outlined"
                        size="small"
                        margin="dense"
                        disabled={
                          watch('tpEstado') !== undefined &&
                          (watch('tpEstado') === '5' ||
                            watch('tpEstado') === '6')
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    {...register('nmMedico')}
                    fullWidth
                    label="Profissional"
                    type="text"
                    disabled
                    variant="outlined"
                    margin="dense"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Atendimento"
                    metodo="buscaAtendimentoAgendamento"
                    value={watch('acAtendimento')}
                    getOptionLabel={(item) =>
                      Array.isArray(item) && item.length > 0
                        ? `Proposta ${item?.[0]?.[0] ?? '-'} - ${item?.[1] ?? ''}`
                        : ''
                    }
                    getOptionSelected={(option, value) =>
                      option?.[0]?.[0] === value?.[0]?.[0]
                    }
                    {...register('acAtendimento')}
                    onChange={(_, value) => {
                      setValue('idPaciente', value?.[0]?.[1] || null)
                      setValue('idAtendimento', value?.[0]?.[0] || null)
                      setValue('dsAgendamento', value?.[1] || '')
                      setValue('cdCpf', value?.[2] || '')
                      setValue('nrTelefone', value?.[3] || '')
                      setValue('dsEmail', value?.[4] || '')
                      setValue('acAtendimento', value || [])
                    }}
                    textFieldProps={{
                      error: !!errors.acAtendimento,
                      helperText: errors.acAtendimento,
                    }}
                    disabled={
                      watch('tpEstado') !== undefined &&
                      (watch('tpEstado') === '5' || watch('tpEstado') === '6')
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    {...register('idTipoAgendamento')}
                    value={watch('idTipoAgendamento')}
                    fullWidth
                    label="Tipo Agendamento"
                    variant="outlined"
                    itemType="number"
                    margin="dense"
                    size="small"
                    disabled={
                      watch('tpEstado') !== undefined &&
                      (watch('tpEstado') === '5' || watch('tpEstado') === '6')
                    }
                    select
                  >
                    {tiposAgendamento.map((item) => {
                      return (
                        <MenuItem key={item[0]} value={item[0]}>
                          {item[1]}
                        </MenuItem>
                      )
                    })}
                  </TextField>
                  {errors.idTipoAgendamento && (
                    <span className="text-red-500 text-xs">
                      {errors.idTipoAgendamento.message}
                    </span>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <PacienteInput
                    {...{ errors, register, setValue, watch }}
                    disabled={
                      watch('tpEstado') !== undefined &&
                      (watch('tpEstado') === '5' || watch('tpEstado') === '6')
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputMask
                    {...register('cdCpf')}
                    mask="999.999.999-99"
                    disabled={
                      watch('tpEstado') !== undefined &&
                      (watch('tpEstado') === '5' || watch('tpEstado') === '6')
                    }
                  >
                    {() => (
                      <TextField
                        {...register('cdCpf')}
                        InputLabelProps={{ shrink: !!watch('cdCpf') }}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        label="CPF"
                        size="small"
                        disabled={
                          watch('tpEstado') !== undefined &&
                          (watch('tpEstado') === '5' ||
                            watch('tpEstado') === '6')
                        }
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    label="E-mail"
                    {...register('dsEmail')}
                    InputLabelProps={{ shrink: !!watch('dsEmail') }}
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    size="small"
                    disabled={
                      watch('tpEstado') !== undefined &&
                      (watch('tpEstado') === '5' || watch('tpEstado') === '6')
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputMask
                    {...register('nrTelefone')}
                    mask="(99) 99999-9999"
                    disabled={
                      watch('tpEstado') !== undefined &&
                      (watch('tpEstado') === '5' || watch('tpEstado') === '6')
                    }
                  >
                    {() => (
                      <TextField
                        {...register('nrTelefone')}
                        InputLabelProps={{ shrink: !!watch('nrTelefone') }}
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        size="small"
                        label="Telefone"
                        disabled={
                          watch('tpEstado') !== undefined &&
                          (watch('tpEstado') === '5' ||
                            watch('tpEstado') === '6')
                        }
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item xs={12}>
                  <Label>Serviços</Label>
                  <Table
                    dados={servicos}
                    head={['Código', 'Descrição', 'Valor']}
                    line={(item) => [
                      item[0],
                      item[1],
                      item[2].toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }),
                    ]}
                    disableFilter
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    {...register('dsObservacao')}
                    fullWidth
                    label="Observação"
                    variant="outlined"
                    size="small"
                    margin="dense"
                    disabled={
                      watch('tpEstado') !== undefined &&
                      (watch('tpEstado') === '5' || watch('tpEstado') === '6')
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controller
                    name="vlConsulta"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <NumericFormat
                        value={value}
                        onValueChange={(values) => {
                          onChange(values.floatValue) // Atualiza o estado com o valor numérico
                        }}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix="R$ "
                        decimalScale={2}
                        fixedDecimalScale
                        size="small"
                        customInput={TextField}
                        fullWidth
                        label="Valor Consulta"
                        variant="outlined"
                        margin="dense"
                        disabled={
                          watch('tpEstado') !== undefined &&
                          (watch('tpEstado') === '5' ||
                            watch('tpEstado') === '6')
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <p
                    style={{
                      fontWeight: '400',
                      fontSize: '14px',
                      display: 'flex',
                      margin: '0px, 0px, 0px, 4px',
                      padding: '0px, 0px, 0px, 4px',
                    }}
                  >
                    {agendamentoSelecionado.data?.[10] && (
                      <span>
                        Confirmou em{' '}
                        <b>
                          {agendamentoSelecionado.data[10]
                            ? dayjs(agendamentoSelecionado.data[10]).format(
                                'DD/MM/YYYY HH:mm',
                              )
                            : ''}
                        </b>
                      </span>
                    )}
                    {agendamentoSelecionado.data?.[11] && (
                      <span style={{ marginLeft: '20px' }}>
                        Chegou às{' '}
                        <b>
                          {agendamentoSelecionado.data[11]
                            ? dayjs(agendamentoSelecionado.data[11]).format(
                                'HH:mm',
                              )
                            : ''}
                        </b>
                      </span>
                    )}
                  </p>
                </Grid>
                <Grid item xs={12} sm={4} />
                <Actions
                  fecharModal={fecharModal}
                  dtExclusao={watch('dtExclusao')}
                  idAgendamento={watch('idAgendamento')}
                  tpEstado={watch('tpEstado')}
                  disabledExcluir={disabledExcluir}
                  disabledSalvar={disabledSalvar}
                  disabledOpcoes={disabledOpcoes}
                  disabledFinalizar={disabledFinalizar}
                />
              </Grid>
            </form>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
